import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var WatchSquare = function WatchSquare(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m17 18.5-.3369 1.1791c-.2377.8319-.3565 1.2479-.5992 1.5567a2 2 0 0 1-.8163.6157C14.8841 22 14.4515 22 13.5862 22h-3.1724c-.8653 0-1.2979 0-1.6614-.1485a2 2 0 0 1-.8163-.6157c-.2427-.3088-.3615-.7248-.5992-1.5567L7 18.5m10-13-.3369-1.1791c-.2377-.832-.3565-1.248-.5992-1.5567a2 2 0 0 0-.8163-.6157C14.8841 2 14.4515 2 13.5862 2h-3.1724c-.8653 0-1.2979 0-1.6614.1485a2 2 0 0 0-.8163.6157c-.2427.3088-.3615.7247-.5992 1.5567L7 5.5M12 9v3l1.5 1.5m-4.8 5h6.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108V8.7c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.9802 5.5 16.4201 5.5 15.3 5.5H8.7c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5.5 7.0198 5.5 7.58 5.5 8.7v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218"
    })
  }));
};
export default WatchSquare;